module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/modules/_redefine.js
// module id = 605
// module chunks = 1